import {
    getData,
} from './Services'

export const getArticulos = async (searchQuery, page, perPage, user_id, orderBy, orden) => {
  console.log("user_id",user_id)
    let res
    if(searchQuery){
        res = await getData(`/articulos/articulos_web?search=${searchQuery}&page=${page}&perPage=${perPage}&user_id=${user_id}&orderBy=${orderBy}&orden=${orden}`);
    }else{
        res = await getData(`/articulos/articulos_web?page=${page}&perPage=${perPage}&user_id=${user_id}&orderBy=${orderBy}&orden=${orden}`);
    }
    return res
}
export const getArticulosByCategory = async ({
  searchTerm,
  ramoId,
  rubroId,
  subrubroId,
  marcaId,
  page,
  perPage,
  user_id,
  orderBy,
  orden
}) => {
  console.log("user_id",user_id)
  const params = new URLSearchParams();

  if (searchTerm) params.append("search", searchTerm);
  if (ramoId) params.append("ramo_Id", ramoId);
  if (rubroId) params.append("rubro_Id", rubroId);
  if (subrubroId) params.append("subrubro_Id", subrubroId);
  if (marcaId) params.append("marca_Id", marcaId);
  if (page) params.append("page", page);
  if (perPage) params.append("perPage", perPage);
  if (user_id) params.append("user_id", user_id);
  if (orderBy) params.append("orderBy", orderBy);
  if (orden) params.append("orden", orden);

  const res = await getData(`/articulos/articulos_web?${params.toString()}`);
  return res;
};

export const getArticuloById = async (id) => {
  const res = await getData(`/articulos/articulo_info/${id}`)
  console.log("resr",res)
  return res
}